(() => {
  if (window.__mpPromoQuickAddInitialized) return;
  window.__mpPromoQuickAddInitialized = true;

  let requestInProgress = false;

  const root = window.Shopify?.routes?.root || '/';

  function getStatus(section) {
    let status = section.querySelector('.mp-promo-cart-status');

    if (!status) {
      status = document.createElement('p');
      status.className = 'mp-promo-cart-status';
      status.setAttribute('role', 'status');
      status.setAttribute('aria-live', 'polite');
      status.style.cssText =
        'position:relative;z-index:2;margin:12px 24px;' +
        'color:inherit;font-size:14px;line-height:1.5;';

      section.append(status);
    }

    return status;
  }

  function showStatus(section, text, includeCartLink = false) {
    const status = getStatus(section);
    status.replaceChildren(document.createTextNode(text));

    if (includeCartLink) {
      const link = document.createElement('a');
      link.href = `${root}cart`;
      link.textContent = ' Ver carrito';
      link.style.cssText =
        'color:inherit;text-decoration:underline;font-weight:700;';

      status.append(link);
    }
  }

  function formatPrice(cents) {
    const currency = window.Shopify?.currency?.active || 'USD';

    try {
      return new Intl.NumberFormat(
        document.documentElement.lang || 'es',
        {
          style: 'currency',
          currency
        }
      ).format(Number(cents) / 100);
    } catch {
      return (Number(cents) / 100).toFixed(2);
    }
  }

  function errorMessage(payload) {
    if (typeof payload?.description === 'string') {
      return payload.description;
    }

    if (typeof payload?.message === 'string') {
      return payload.message;
    }

    return 'No se pudo añadir el producto. Intenta de nuevo.';
  }

  async function addToDrawer({
    variantId,
    sourceButton,
    section,
    submitButton,
    dialog
  }) {
    if (requestInProgress) return;

    const drawer = document.querySelector('cart-drawer');

    // Comprobar el carrito antes de enviar una compra.
    if (
      !drawer ||
      typeof drawer.renderContents !== 'function' ||
      typeof drawer.getSectionsToRender !== 'function'
    ) {
      const message =
        'El carrito lateral no está disponible en esta página.';

      showStatus(section, message, true);

      if (dialog) {
        dialog.querySelector('[data-promo-dialog-message]').textContent =
          message;
      }

      return;
    }

    if (!variantId || !/^\d+$/.test(String(variantId))) {
      showStatus(section, 'No se encontró una variante disponible.');
      return;
    }

    requestInProgress = true;

    const originalContent = submitButton.innerHTML;
    let productWasAdded = false;

    submitButton.disabled = true;
    submitButton.setAttribute('aria-busy', 'true');
    submitButton.textContent = '…';

const previousStatus = section.querySelector('.mp-promo-cart-status');
if (previousStatus) previousStatus.remove();

    try {
      const sectionIds = drawer
        .getSectionsToRender()
        .map(item => item.id);

      if (typeof drawer.setActiveElement === 'function') {
        drawer.setActiveElement(sourceButton);
      }

      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          id: String(variantId),
          quantity: 1,
          sections: sectionIds,
          sections_url: window.location.pathname
        })
      });

      const payload = await response.json();

      if (!response.ok || payload.status) {
        throw new Error(errorMessage(payload));
      }

      productWasAdded = true;

      const parser = new DOMParser();

      // Validar el HTML antes de pasarlo al carrito.
      for (const item of drawer.getSectionsToRender()) {
        const html = payload.sections?.[item.id];

        if (typeof html !== 'string' || !html.trim()) {
          throw new Error('No se recibió el contenido del carrito.');
        }

        const documentFragment = parser.parseFromString(
          html,
          'text/html'
        );

        const targetSelector = item.selector || '.shopify-section';

        if (!documentFragment.querySelector(targetSelector)) {
          throw new Error('El contenido del carrito está incompleto.');
        }
      }

      if (dialog?.open) {
        dialog.close();
      }

      // El contenedor exterior también puede conservar
      // la clase del carrito vacío.
      drawer.classList.remove('is-empty');

      // Este método actualiza el panel, el contador
      // y abre el carrito mediante tu implementación.
      drawer.renderContents(payload);

const status = section.querySelector('.mp-promo-cart-status');
if (status) status.remove();
    } catch (error) {
      if (productWasAdded) {
        const message =
          'El producto se añadió, pero no se pudo actualizar el panel. ' +
          'Revisa el carrito antes de volver a añadirlo.';

        if (dialog?.open) {
          dialog.close();
        }

        showStatus(section, message, true);
      } else {
        const message =
          error instanceof Error
            ? error.message
            : 'No se pudo añadir el producto.';

        showStatus(section, message);

        if (dialog?.open) {
          dialog.querySelector('[data-promo-dialog-message]')
            .textContent = message;
        }
      }
    } finally {
      requestInProgress = false;
      submitButton.disabled = false;
      submitButton.removeAttribute('aria-busy');
      submitButton.innerHTML = originalContent;
    }
  }

  function openVariantDialog(card, sourceButton, section, variants) {
    if (document.querySelector('[data-promo-variant-dialog]')) return;

    const dialog = document.createElement('dialog');

    dialog.setAttribute('data-promo-variant-dialog', '');
    dialog.setAttribute('aria-label', 'Elegir variante');
    dialog.style.cssText =
      'width:min(420px,calc(100% - 32px));max-height:85vh;' +
      'padding:24px;border:0;border-radius:14px;' +
      'background:#fff;color:#222;overflow:auto;' +
      'box-shadow:0 12px 60px rgba(0,0,0,.3);';

    const heading = document.createElement('h2');
    heading.textContent = card.dataset.productTitle || 'Elegir variante';
    heading.style.cssText =
      'margin:0 0 18px;color:#222;font-size:20px;line-height:1.3;';

    const form = document.createElement('form');

    const label = document.createElement('label');
    label.textContent = 'Selecciona una opción';
    label.style.cssText =
      'display:block;margin-bottom:8px;font-size:14px;';

    const select = document.createElement('select');
    select.required = true;
    select.style.cssText =
      'display:block;width:100%;min-height:46px;padding:10px;' +
      'border:1px solid #bbb;border-radius:6px;' +
      'background:#fff;color:#222;font-size:16px;';

    label.append(select);

    for (const variant of variants) {
      const option = document.createElement('option');

      option.value = String(variant.id);
      option.disabled = !variant.available;
      option.textContent =
        `${variant.title} — ${formatPrice(variant.price)}` +
        (variant.available ? '' : ' — Agotado');

      select.append(option);
    }

    const firstAvailable = variants.find(variant => variant.available);

    if (firstAvailable) {
      select.value = String(firstAvailable.id);
    }

    const submitButton = document.createElement('button');
    submitButton.type = 'submit';
    submitButton.textContent = 'Añadir al carrito';
    submitButton.disabled = !firstAvailable;
    submitButton.style.cssText =
      'display:block;width:100%;min-height:46px;margin-top:16px;' +
      'padding:12px;border:0;border-radius:8px;background:#228040;' +
      'color:#fff;font-size:15px;font-weight:700;cursor:pointer;';

    const message = document.createElement('p');
    message.setAttribute('data-promo-dialog-message', '');
    message.setAttribute('role', 'status');
    message.style.cssText = 'font-size:13px;line-height:1.5;';

    const closeButton = document.createElement('button');
    closeButton.type = 'button';
    closeButton.textContent = 'Cancelar';
    closeButton.style.cssText =
      'display:block;min-height:44px;margin:8px auto 0;padding:8px 16px;' +
      'background:transparent;border:0;text-decoration:underline;' +
      'color:#333;cursor:pointer;';

    closeButton.addEventListener('click', () => dialog.close());

    form.addEventListener('submit', event => {
      event.preventDefault();

      const selectedVariant = variants.find(
        variant => String(variant.id) === select.value
      );

      if (!selectedVariant?.available) return;

      message.textContent = '';

      addToDrawer({
        variantId: selectedVariant.id,
        sourceButton,
        section,
        submitButton,
        dialog
      });
    });

    dialog.addEventListener('close', () => {
      dialog.remove();

      if (sourceButton.isConnected) {
        sourceButton.focus({ preventScroll: true });
      }
    }, { once: true });

    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;

      const bounds = dialog.getBoundingClientRect();

      if (
        event.clientX < bounds.left ||
        event.clientX > bounds.right ||
        event.clientY < bounds.top ||
        event.clientY > bounds.bottom
      ) {
        dialog.close();
      }
    });

    form.append(label, submitButton, message, closeButton);
    dialog.append(heading, form);
    document.body.append(dialog);
    dialog.showModal();
    select.focus();
  }

  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;

    const button = event.target.closest('.mp-promo-quick-add');
    if (!button) return;

    const section = button.closest('.mp-promo');
    const card = button.closest('.mp-promo__card[data-card-id]');

    if (!section || !card) return;

    event.preventDefault();

    if (requestInProgress || button.disabled) return;

    try {
      const variants = JSON.parse(card.dataset.variants || '[]');

      if (!Array.isArray(variants) || variants.length === 0) {
        throw new Error('No se encontraron las variantes del producto.');
      }

      if (card.dataset.hasVariants === 'true') {
        openVariantDialog(card, button, section, variants);
        return;
      }

      addToDrawer({
        variantId: card.dataset.firstVariant,
        sourceButton: button,
        section,
        submitButton: button,
        dialog: null
      });
    } catch (error) {
      showStatus(
        section,
        error instanceof Error
          ? error.message
          : 'No se pudo preparar la compra rápida.'
      );
    }
  });
})();
